import "./styles/globals.css"

import { Analytics } from '@vercel/analytics/react'
import App from "./app/App"
import { HelmetProvider } from "react-helmet-async"
import React from "react"
import ReactDOM from "react-dom/client"
import Clarity from '@microsoft/clarity'
import { WhatsAppFloat } from "@/shared/components/common/WhatsAppFloat"

const projectId = "tq7t5yug3f"
Clarity.init(projectId)
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <div className="font-sans">
        <App />
        <Analytics />
      </div>
       <WhatsAppFloat />
    </HelmetProvider>
  </React.StrictMode>,
)
